let isInitialized = false;

export function initSettings(): void {
  if (isInitialized) return;
  isInitialized = true;

  // Use delegation to handle the change event for the avatar input
  document.addEventListener("change", (event) => {
    const target = event.target as HTMLInputElement;

    // Check if the changed element is the avatar input
    if (target && target.id === "user_avatar") {
      const file = target.files?.[0];
      const avatarPreview = document.getElementById(
        "avatar-preview",
      ) as HTMLImageElement;

      if (file && avatarPreview) {
        // Check file size (1MB limit)
        if (file.size > 1024 * 1024) {
          alert("File is too large. Maximum size is 1MB.");
          target.value = ""; // Reset input
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          if (e.target?.result) {
            avatarPreview.src = e.target.result as string;
          }
        };
        reader.readAsDataURL(file);

        // Auto-submit the form to save changes immediately
        const form = target.closest("form");
        if (form) {
          form.requestSubmit();
        }
      }
    }
  });
}

// Auto-initialize when loaded directly
document.addEventListener("turbo:load", () => {
  if (document.querySelector('[data-controller="settings"]')) {
    initSettings();
  }
});
